import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=aac9b0c6&scoped=true"
import script from "./set-password.vue?vue&type=script&lang=js"
export * from "./set-password.vue?vue&type=script&lang=js"
import style0 from "./set-password.vue?vue&type=style&index=0&id=aac9b0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac9b0c6",
  null
  
)

export default component.exports